module.exports = __webpack_public_path__ + "resources/img/bg_cover_customer.e23e0094ec9845f6dc038bca353e513f.png";